import { font } from 'modules/styles';
import styled from 'styled-components';

const SectionHeaderText = styled.div`
    ${font(14, '#000000', 'semibold')}
    margin-bottom: 12px;
`;

export default SectionHeaderText;
